import { render } from "./SettingsImportSection.vue?vue&type=template&id=40b2ca21"
import script from "./SettingsImportSection.vue?vue&type=script&lang=js"
export * from "./SettingsImportSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__